import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ToiletCard.css';


const ToiletCard = ({ title, dimensions, isDouble }) => {
  const Navigate = useNavigate()

  return (
    <div className="toilet-card">
      <h2 className="card-title">{title}</h2>
      <ul className="dimension-list">
        {Object.entries(dimensions).map(([key, value]) => (
          <li key={key} className="dimension-item">
            {value}
          </li>
        ))}
      </ul>
      <button className="order-button" onClick={()=> Navigate("/contact-us")}>ORDER NOW</button>
    </div>
  );
};

export default ToiletCard;